import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Badge } from '../../primitives/Alert/components/Badge.js';
import { Container } from '../../primitives/Alert/components/Container.js';
import { Content } from '../../primitives/Alert/components/Content.js';
import { Controls } from '../../primitives/Alert/components/Controls.js';
import { getIcon } from '../../primitives/Alert/utlis/getIcon.js';
import { ParagraphMedium, ParagraphMediumBold } from '../../primitives/Typography/index.js';
const AlertUI = ({
  variant = 'info',
  controls,
  caption,
  withIcon = true,
  children,
  ...restProps
}, ref) => {
  return _jsxs(Container, {
    ref: ref,
    variant: variant,
    ...restProps,
    children: [withIcon && _jsx(Badge, {
      children: getIcon(variant)
    }), _jsxs(Content, {
      children: [_jsxs("div", {
        children: [caption && _jsx(ParagraphMediumBold, {
          children: caption
        }), children && _jsx(ParagraphMedium, {
          children: children
        })]
      }), controls && _jsx(Controls, {
        children: controls
      })]
    })]
  });
};
export const Alert = /*#__PURE__*/_styled(forwardRef(AlertUI), {
  label: 'Alert',
  target: "ejpqrg80"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkFsZXJ0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNHIiwiZmlsZSI6IkFsZXJ0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3gsIGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBCYWRnZSB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvQWxlcnQvY29tcG9uZW50cy9CYWRnZS5qcyc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0FsZXJ0L2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmltcG9ydCB7IENvbnRlbnQgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0FsZXJ0L2NvbXBvbmVudHMvQ29udGVudC5qcyc7XG5pbXBvcnQgeyBDb250cm9scyB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvQWxlcnQvY29tcG9uZW50cy9Db250cm9scy5qcyc7XG5pbXBvcnQgeyBnZXRJY29uIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9BbGVydC91dGxpcy9nZXRJY29uLmpzJztcbmltcG9ydCB7IFBhcmFncmFwaE1lZGl1bSwgUGFyYWdyYXBoTWVkaXVtQm9sZCB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvVHlwb2dyYXBoeS9pbmRleC5qcyc7XG5jb25zdCBBbGVydFVJID0gKHsgdmFyaWFudCA9ICdpbmZvJywgY29udHJvbHMsIGNhcHRpb24sIHdpdGhJY29uID0gdHJ1ZSwgY2hpbGRyZW4sIC4uLnJlc3RQcm9wcyB9LCByZWYpID0+IHtcbiAgICByZXR1cm4gKF9qc3hzKENvbnRhaW5lciwgeyByZWY6IHJlZiwgdmFyaWFudDogdmFyaWFudCwgLi4ucmVzdFByb3BzLCBjaGlsZHJlbjogW3dpdGhJY29uICYmIF9qc3goQmFkZ2UsIHsgY2hpbGRyZW46IGdldEljb24odmFyaWFudCkgfSksIF9qc3hzKENvbnRlbnQsIHsgY2hpbGRyZW46IFtfanN4cyhcImRpdlwiLCB7IGNoaWxkcmVuOiBbY2FwdGlvbiAmJiBfanN4KFBhcmFncmFwaE1lZGl1bUJvbGQsIHsgY2hpbGRyZW46IGNhcHRpb24gfSksIGNoaWxkcmVuICYmIF9qc3goUGFyYWdyYXBoTWVkaXVtLCB7IGNoaWxkcmVuOiBjaGlsZHJlbiB9KV0gfSksIGNvbnRyb2xzICYmIF9qc3goQ29udHJvbHMsIHsgY2hpbGRyZW46IGNvbnRyb2xzIH0pXSB9KV0gfSkpO1xufTtcbmV4cG9ydCBjb25zdCBBbGVydCA9IHN0eWxlZChmb3J3YXJkUmVmKEFsZXJ0VUkpLCB7XG4gICAgbGFiZWw6ICdBbGVydCcsXG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUFsZXJ0LmpzLm1hcCJdfQ== */");